import { useTheme } from '@fluentui/react';
import AppContext from 'App/AppContext';
import { IPIconButton, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapExtraSmall } from 'globalStyles';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

interface ITaskIdBadgeProps {
  taskId: number;
  showTaskId: boolean;
}

// "#104727" in the muted body colour plus a one-click copy button. Renders nothing for a new task or while
// the "Show task ID" toggle in the footer is off.
export const TaskIdBadge = (props: ITaskIdBadgeProps) => {
  const { t } = useTranslation(['task']);
  const appContext = useContext(AppContext);
  const theme = useTheme();

  const copyId = async () => {
    try {
      await navigator.clipboard.writeText(props.taskId.toString());
      appContext.showNotification(t('task:Detail.IdCopied'), false, false, true);
    } catch {
      appContext.showNotification(t('task:Detail.IdCopyFailed'), true, false, true);
    }
  };

  if (!props.showTaskId || props.taskId <= 0) return null;

  return (
    <IPStack
      horizontal
      verticalAlign="center"
      tokens={globalStackTokensGapExtraSmall}
      styles={{ root: { flexShrink: 0 } }}
    >
      <IPText variant="large" styles={{ root: { color: theme.semanticColors.bodySubtext, whiteSpace: 'nowrap' } }}>
        {`#${props.taskId}`}
      </IPText>
      <IPIconButton
        className="isoplanner-task-copyid"
        iconProps={{ iconName: 'Copy' }}
        title={t('task:Detail.CopyId', { id: props.taskId })}
        onClick={() => void copyId()}
      />
    </IPStack>
  );
};
